import { render } from "./PopUp2.vue?vue&type=template&id=6608cc98&scoped=true"
import script from "./PopUp2.vue?vue&type=script&lang=js"
export * from "./PopUp2.vue?vue&type=script&lang=js"

import "./PopUp2.vue?vue&type=style&index=0&id=6608cc98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6608cc98"]])

export default __exports__